module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/lion-mobile.6211301d.png";